import { Vector3 } from '@react-three/fiber'
import { Helper } from '../../../../../classes/helper'
import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { Shape } from 'three'
import { Keys } from '../../../../../hooks/state/utlility/utils'

interface Props {
  index: number
  position: number[]
}

export const ShellHandle = ({ index, position }: Props): JSX.Element => {
  const { sidwallTyp, type, spaceBetween, spaceBetweenY } = useSidewall()

  const hole = new Shape()
  hole
    .moveTo(0, 0)
    .absarc(0, 0, 0.02, 0, Math.PI * 2, false)
    .absarc(0, 0, 0.01, 0, Math.PI * 2, true)

  const extrudeSettings = {
    depth: sidwallTyp.glas + 0.005,
    bevelEnabled: false,
    bevelSegments: 2,
    steps: 1,
    bevelSize: 0.1,
    bevelThickness: 0.21,
  }

  const pos: Vector3 = [
    position[0] +
      (type === Keys.Seitenwände.Values.SeitenwandRechts.key
        ? -sidwallTyp.glas - 0.05
        : 0.02 + sidwallTyp.glas),
    position[1],
    position[2],
  ]
  return (
    <mesh
      castShadow={true}
      position={pos}
      rotation={[
        Helper.convertAngleToRadiant(0),
        Helper.convertAngleToRadiant(90),
        Helper.convertAngleToRadiant(0),
      ]}
    >
      <extrudeGeometry attach="geometry" args={[hole, extrudeSettings]} />

      <CachedMeshPhysicalMaterial
        color={'silver'}
        opacity={0.99}
        roughness={1}
        metalness={0}
        envMapIntensity={0.2}
      />
    </mesh>
  )
}
